<script setup lang="ts">
// #719 観点B: モバイルナビ背景に敷くエリアのマップ画像。
import portMapBg from '@/assets/images/map/AreaMap_BeginnersPort.webp'

const runtimeConfig = useRuntimeConfig()

const { isMobile } = useIsMobile()

useSeoMeta({
  title: 'はじまりの港 | Code & Magic',
  description: 'エンコーディア南部にある、港です。',
  ogTitle: 'はじまりの港 | Code & Magic',
  ogDescription: 'エンコーディア南部にある、港です。',
  ogImage: `${runtimeConfig.public.serviceDomain}/images/ogPlayMakeShare_wLogo.webp`,
  twitterCard: 'summary_large_image',
})

definePageMeta({
  middleware: ['authenticated', 'confirm-game-state'],
  layout: false,
  usePageReady: true,
})

const { finishLoading } = usePageReady()

onMounted(async () => {
  await finishLoading()
})
</script>

<template>
  <NuxtLayout :name="isMobile ? 'mobile-nav' : 'centering43'">
    <SceneMap
      scene-id="wld_beginnersPort"
      :mobile="isMobile"
      :mobile-background="portMapBg"
    >
      <template #map>
        <v-img
          src="@/assets/images/map/AreaMap_BeginnersPort.webp"
          width="100%"
          height="auto"
          lazy-src="@/assets/images/map/LazyAreaMap_BeginnersPort.png"
          :transition="false"
        />
        <svg
          class="map-area"
          width="100%"
          height="100%"
          viewBox="0 0 1024 768"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          xml:space="preserve"
          xmlns:serif="http://www.serif.com/"
          style="
          fill-rule: evenodd;
          clip-rule: evenodd;
          stroke-linecap: round;
          stroke-linejoin: round;
          stroke-miterlimit: 1.5;
        "
        >
          <path
            data-scene-id="prt_beginnersHouse"
            d="M344.005,314.371c6.212,4.142 41.92,36.939 49.752,74.968c6.221,30.207 -1.294,76.018 -31.208,92.608c-20.442,11.337 -67.068,16.476 -94.643,11.873c-23.612,-3.942 -53.246,-28.513 -57.781,-73.159c-4.446,-43.768 16.21,-88.407 30.304,-103.463c20.601,-22.009 85.193,-15.082 103.576,-2.827Z"
            class="scene"
          />
        </svg>
      </template>
    </SceneMap>
  </NuxtLayout>
</template>
